import { render } from "./shimmer.vue?vue&type=template&id=459a1d9a&scoped=true&ts=true"
import script from "./shimmer.vue?vue&type=script&lang=ts"
export * from "./shimmer.vue?vue&type=script&lang=ts"

import "./shimmer.vue?vue&type=style&index=0&id=459a1d9a&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-459a1d9a"]])

export default __exports__